
  import { defineComponent } from 'vue';

  import ExportButtons from '@/common/components/redesigned/ExportButtons.vue';

  export default defineComponent({
    name: 'StatisticsExportButtons',
    components: {
      ExportButtons,
    },
    emits: ['exportPdf', 'exportExcel'],
    props: {
      disabled: {
        type: Boolean,
        default: false,
      },
      loading: {
        type: Boolean,
        default: false,
      },
      permissionCode: {
        type: Number,
        required: true,
      },
    },
    computed: {
      permissionCodes() {
        return {
          pdf: this.permissionCode,
          excel: this.permissionCode,
        };
      },
    },
    methods: {
      exportPdf() {
        this.$emit('exportPdf');
      },
      exportExcel() {
        this.$emit('exportExcel');
      },
    },
  });
